import React, { useState } from 'react';
import DataGridToolbar from 'components/datagrid/DataGridToolbar';
import DeleteCategoriesDialog from './DeleteCategoriesDialog';
import { RiArrowUpDownLine } from 'react-icons/ri';
import CategoryReorderDialog from './CategoryReorderDialog';
import { useTranslation } from 'services/localization';
import { CategoriesTableRow } from './rows';

const CategoriesTableToolbar = () => {
	const { t } = useTranslation();
	const [activeModal, setActiveModal] = useState<{
		id: 'delete' | 'reorder';
		rowIds: string[];
	} | null>(null);

	const activeModalId = activeModal?.id;
	const activeModalRowIds = activeModal?.rowIds ?? [];

	const renderActiveDialog = () => {
		switch (activeModalId) {
			case 'delete': {
				return (
					<DeleteCategoriesDialog
						categoryIds={activeModalRowIds}
						onClose={() => setActiveModal(null)}
					/>
				);
			}
			case 'reorder': {
				return <CategoryReorderDialog onClose={() => setActiveModal(null)} />;
			}
			default:
				return null;
		}
	};

	return (
		<>
			<DataGridToolbar
				persistKey="CategoriesTable"
				exportFileName="rentle-categories"
				selectedRowsActions={{
					deleteAction: {
						enabled: true,
						handler: (rowIds) => setActiveModal({ id: 'delete', rowIds }),
						permissionsFields: ['canDelete'],
					},
					exportAction: {
						enabled: true,
					},
					getRowLabel: (row: CategoriesTableRow) => row.name,
				}}
				toolbarActions={[
					{
						label: t('common:actions.reorder', 'Reorder'),
						icon: RiArrowUpDownLine,
						handler: () => setActiveModal({ id: 'reorder', rowIds: [] }),
					},
				]}
			/>
			{renderActiveDialog()}
		</>
	);
};

export default CategoriesTableToolbar;
